import { render, staticRenderFns } from "./manual-test-paper.vue?vue&type=template&id=5076694e"
import script from "./manual-test-paper.vue?vue&type=script&lang=js"
export * from "./manual-test-paper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports